// From a given query get the alternate format version of it. (Tree vs List)
export function getAlternateFormatQueryFrom(query: string): string {
  const parts = query.replace(/\n/gm, ' ').split(/\breturn\b/i);
  if (!query) {
    return '';
  }

  // Is ALREADY a tree query?
  if (parts[1] && parts[1].match(/\btree\b/i)) {
    // Give back query without `RETURN TREE` in it.
    return parts[0].trim() + parts[1].replace(/(\b|\s)tree(\b|\s)/i, '');
  } else if (parts[1] && parts[1].match(/\b(order|skip|limit)\b/i)) {
    // Give back query replacing field selections as TREE
    return (
      parts[0].trim() +
      ' RETURN ' +
      parts[1].replace(/(.*?)\b(order|skip|limit)\b/i, 'tree $2')
    );
  } else {
    // If has ORDER, SKIP or LIMIT, insert RETURN TREE
    if (parts[0].match(/\b(order|skip|limit)\b/i)) {
      return parts[0].replace(/\b(order|skip|limit)\b/i, 'RETURN tree $1');
    } else {
      // Otherwise, append the undefined return type as TREE
      return parts[0].trim() + ' RETURN tree';
    }
  }
}
